import { useSearchParams } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { Eyebrow, MaskLine, Reveal, SectionHeading } from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";

const Contact = () => {
  const [params] = useSearchParams();
  const subject = params.get("subject") || "";

  return (
    <>
      <section data-testid="contact-hero" className="cta-glow pb-24 pt-44 sm:pb-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Eyebrow className="text-gold">Contact Us</Eyebrow>
          <h1 className="mt-6 max-w-4xl font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
            <MaskLine delay={0.15}>Let's start a</MaskLine>
            <MaskLine delay={0.3}>conversation.</MaskLine>
          </h1>
          <Reveal delay={0.5}>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-white/70 md:text-lg">
              Have a business idea, partnership opportunity or technology requirement?
              We'd love to hear from you.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-24 sm:py-32">
        <div className="mx-auto grid max-w-7xl gap-16 px-5 sm:px-8 lg:grid-cols-[1fr_1.3fr]">
          <div>
            <SectionHeading
              eyebrow="Reach Us"
              title="Sunkev Enterprises Private Limited"
              text="Send us a message using the form and our team will get back to you."
            />
            <div className="mt-10 space-y-5">
              {[
                { Icon: Mail, k: "Email", v: "sunkeventerprises@gmail.com" },
                { Icon: Phone, k: "Phone", v: "+91 93924 81929" },
                { Icon: MapPin, k: "Address", v: "19-3-1A/S9, Postal Colony, Korrameenugunta, Renigunta Rd, Tirupati – 517501, Andhra Pradesh, India" },
              ].map(({ Icon, k, v }) => (
                <Reveal key={k}>
                  <div className="flex items-start gap-4 rounded-2xl border border-gray-100 bg-mist p-6">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy">
                      <Icon className="h-5 w-5 text-gold" />
                    </span>
                    <div>
                      <p className="text-xs font-semibold uppercase tracking-wider text-fog">{k}</p>
                      <p className="mt-1 text-sm font-medium text-ink" data-testid={`contact-info-${k.toLowerCase()}`}>{v}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.15}>
              <div className="mt-8 rounded-2xl border border-gold/25 bg-gold/5 p-6">
                <p className="text-sm leading-relaxed text-ink">
                  <span className="font-semibold">Interested in Craftsi?</span> Whether you're
                  a customer, a local business or a potential partner — mention it in your
                  message and we'll route it to the right team.
                </p>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <ContactForm defaultSubject={subject} />
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default Contact;
